import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";
import UpdateAnimationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/UpdateAnimationRequest";

export default class CreateAnimationViewModel {
    id?: string = '';
	name?: string = '';
	base64Content?: string = '';
	_videoUrl?: string = '';
    private _videoFile: File = null;
    get videoFile(): File {
        return this._videoFile;
    }
    set videoFile(file: File) {
        this._videoFile = file;
        const reader = new FileReader();
        reader.onload = () => {
            this.base64Content = reader.result.toString();
        }
        reader.readAsDataURL(file);
    }
    get videoUrl(): string | Blob {
        if (this.videoFile) {
            var blob = window.URL || window.webkitURL;
            return blob.createObjectURL(this.videoFile);
        }
        return this._videoUrl;
    }
    set videoUrl(value: string | Blob) {
        this._videoUrl = value.toString();
    }
	toServerModel(): UpdateAnimationRequest {
		const req = new UpdateAnimationRequest({
			Id: this.id,
            Name: this.name,
            Base64Content: this.base64Content
		});
		return req;
	}
	fromServerModel(model: AnimationResponse) {
		this.id = model.Id;
		this.name = model.Name;
        this._videoUrl = model.Url;
	}
}